export default __webpack_public_path__ + "static/media/ded-contact-whatsapp.f788ccc0.svg";